import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Call, Sms, Location } from "iconsax-reactjs";

const ContactUs = () => {
  const form = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");

    if (!form.current) return;

    emailjs
      .sendForm(
        "service_zkw5huo", // replace
        "template_9979cyd", // replace
        form.current,
        "yLC-9A6O9nSJbbV3W" // replace
      )
      .then(
        () => {
          setStatus("success");
          form.current?.reset();
        },
        (e) => {
          console.log("sendEmailData", e);
          setStatus("error");
        }
      )
      .catch((e) => {
        console.log("error", e);
      });
  };

  return (
    <section
      id="Contact-Us"
      className="bg-[#FBF9F9] py-24 px-6 sm:px-12 lg:px-32"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* Left: Form */}
        <div>
          <h2 className="text-[#24215A] changa-one-regular text-4xl mb-6">
            Get in Touch
          </h2>
          <p className="text-gray-600 mb-8">
            Have questions? Reach out by filling the form below and we’ll get
            back to you soon.
          </p>
          <form ref={form} onSubmit={sendEmail} className="space-y-6">
            <div>
              <input
                type="text"
                name="from_name" // ✅ matches EmailJS template
                placeholder="Your Name"
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#EEB762] focus:outline-none"
              />
            </div>
            <div>
              <input
                type="email"
                name="reply_to" // ✅ matches EmailJS template
                placeholder="Your Email"
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#EEB762] focus:outline-none"
              />
            </div>
            <div>
              <textarea
                name="message" // ✅ matches EmailJS template
                placeholder="Your Message"
                rows={5}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#EEB762] focus:outline-none"
              ></textarea>
            </div>
            <input type="hidden" name="to_email" value="info@primesteel.com" />
            <button
              type="submit"
              disabled={status === "loading"}
              className="bg-[#EEB762] text-white px-8 py-3 rounded-lg hover:bg-[#d9a553] transition disabled:opacity-50"
            >
              {status === "loading" ? "Sending..." : "Send Message"}
            </button>
            {status === "success" && (
              <p className="text-green-600 mt-2">
                Message sent successfully ✅
              </p>
            )}
            {status === "error" && (
              <p className="text-red-600 mt-2">Oops! Something went wrong ❌</p>
            )}
          </form>
        </div>

        {/* Right: Details */}
        <div className="bg-white shadow-lg rounded-2xl p-8 space-y-8">
          <h3 className="text-2xl font-semibold text-[#24215A]">
            Contact Details
          </h3>
          <div className="flex items-start gap-4">
            <Call size="28" color="#EEB762" variant="Bold" />
            <div>
              <p className="font-medium">Phone</p>
              <p className="text-gray-600">+2519-64-33-33-33</p>
              <p className="text-gray-600">+2519-11-25-23-97</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <Sms size="28" color="#EEB762" variant="Bold" />
            <div>
              <p className="font-medium">Email</p>
              <p className="text-gray-600">info@primesteel.com</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <Location size="28" color="#EEB762" variant="Bold" />
            <div>
              <p className="font-medium">Address</p>
              <p className="text-gray-600">
                Teklehaymanot, around Berbere Berenda <br />
                Waliya Building, 50m above
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
